import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { setSessonToken } from '../../store/publicStore/actions/utilsActions/utilsActions';
import { getUserInfo, getUserInfoReset } from '../../store/authStore/actions/authActions/getUserInfoActions';
import { useToast } from '../../hooks/useToast';
import GlobalLoader from '../../components/common/GlobalLoader/GlobalLoader';

const AuthCallback = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const Toast = useToast();
    const getUserInfoReducer = useSelector(state => state.getUserInfoReducer);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');
        const error = queryParams.get('error');

        if (token) {
            // 1. Set the session token in Redux
            dispatch(setSessonToken(token));
            // 2. Fetch user information
            dispatch(getUserInfo());
        } else if (error) {
            Toast(error.replace(/_/g, ' '), 'error');
            navigate('/login');
        } else {
            navigate('/login');
        }
    }, [dispatch, location, navigate, Toast]);

    useEffect(() => {
        if (getUserInfoReducer.status === 200) {
            const userType = getUserInfoReducer?.data?.userType;
            if (userType === "BRAND") {
                navigate('/brand');
            } else if (userType === "INFLUENCER") {
                navigate('/influencer');
            } else if (userType === "AGENCY") {
                navigate('/agency');
            } else {
                Toast("Unknown user type", 'error');
                navigate('/login');
            }
        } else if (getUserInfoReducer.status === 403) {
            Toast(getUserInfoReducer.message, 'error');
            dispatch(getUserInfoReset());
            navigate('/login');
        } else if (getUserInfoReducer.status && getUserInfoReducer.status !== 200) {
            Toast(getUserInfoReducer.message || "Failed to get user info", 'error');
            dispatch(getUserInfoReset());
            navigate('/login');
        }
    }, [getUserInfoReducer, navigate, Toast, dispatch]);

    return (
        <div className="flex items-center justify-center min-h-screen">
            <GlobalLoader />
            <p className="inter-font text-[1.6rem]">Completing sign in...</p>
        </div>
    );
};

export default AuthCallback;
